import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

import wmsBaseService from '../../../service/wms/wmsBase.service';
import { useLoader } from '../../../provider/LoaderProvider';
import { dataGridPremiumColumns } from '../../../utils/helper';
import DeleteButton from '../Components/DeleteButton';
import NextButton from '../Components/NextButton';
import addNotification from '../../../utils/addNotification';
import { NotificationType } from '../../../config';
import { DataGridIdentifiers } from '../../Interface/Datagrid/DataGridIdentifiers';
import DatagridPremiumUi from '../../Interface/DatagridPremmium/DataGridPremiumUI';
import { WmsType } from '../../../config/wms/wmsType';

const wmsType = WmsType.InventoryTransfer;

const InprogressInventoryTransfer = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(false);
  const { showLoader, hideLoader } = useLoader();

  const handleFetchData = async () => {
    setLoading(true);
    showLoader();
    try {
      const data = await wmsBaseService.getData({ wmsType });
      setData(data.rows);
    } finally {
      setLoading(false);
      hideLoader();
    }
  };

  const handleContinue = (wmsEntry) => {
    navigate(`../inventoryTransferDoc/${wmsEntry}`);
  };

  const handleDelete = async (wmsEntry) => {
    showLoader();
    try {
      await wmsBaseService.deleteData(wmsEntry, wmsType);
      handleFetchData();
      return addNotification({
        content: `Sikeres törlés!`,
        type: NotificationType.WARNING,
      });
    } catch (e) {
      addNotification({
        content: `Hiba történt a törlés során!`,
        type: NotificationType.ERROR,
      });
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
    handleFetchData();
  }, []);

  const columns = dataGridPremiumColumns([
    {
      field: 'id',
      headerName: '#',
      flex: 0.25,
    },
    {
      field: 'createdAt',
      headerName: 'Folyamatban',
      flex: 1,
      renderCell: (data) => {
        return (
          <div>
            <Typography variant="body1" fontWeight="bold">
              {data.row.whsCode}
            </Typography>
            <Typography variant="body2">Létrehozta: {data.row.UserName}</Typography>
            <Typography variant="body2">{dayjs(data.row.createdAt).format('YYYY.MM.DD HH:mm')}</Typography>
          </div>
        );
      },
    },

    {
      field: 'operators',
      headerName: '',
      flex: 0.45,
      sortable: false,
      renderCell: (data) => {
        return (
          <Box
            sx={{
              display: 'flex',
              flexDirection: {
                xs: 'column',
                sm: 'row',
              },
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <NextButton onClick={() => handleContinue(data.row.id)} />
            <DeleteButton onClick={() => handleDelete(data.row.id)} />
          </Box>
        );
      },
    },
  ]);

  return (
    <Box sx={{ pb: 2, pt: 3, px: 0, width: '100%' }}>
      <DatagridPremiumUi
        datagridIdentifier={DataGridIdentifiers.wmsInventoryTransferInProgress}
        rows={data}
        columns={columns}
        loading={loading}
        sx={{ width: '100%' }}
        getRowHeight={() => 'auto'}
        headerFilters={false}
        slots={{
          toolbar: null,
        }}
      />
    </Box>
  );
};

export default InprogressInventoryTransfer;
